import { SettingConst } from '@faire/web-api--source/types';

/**
 * Setting that enables email opt-in nudges.
 * https://www.notion.so/faire/Europe-email-opt-in-nudge-8568ea5fe67d4db4908419970f483523
 */
export const ENABLE_OPT_IN_NUDGE = 'ENABLE_OPT_IN_NUDGE' as SettingConst<
  'ENABLE_OPT_IN_NUDGE',
  boolean,
  'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'VISITOR_WEB'
>;
